import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScreeningCaseCompositeEntity, ScreeningCaseReviewStatusKey } from '@nk/data-entities-lib';
import { getLatestScreeningCaseReviewCompositeEntity } from '../../utils/screening-case.utils';

interface ScreeningCaseItemLike {
  data: ScreeningCaseCompositeEntity;
}

interface ReviewProgressStats {
  completed: number;
  total: number;
  percentage: number;
}

@Component({
  selector: 'nk-screening-case-review-progress',
  imports: [TranslateModule],
  templateUrl: './screening-case-review-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCaseReviewProgressComponent {
  public items = input.required<ScreeningCaseItemLike[]>();

  public stats = computed<ReviewProgressStats>(() => {
    const items = this.items();
    const total = items.length;

    if (total === 0) {
      return { completed: 0, total: 0, percentage: 0 };
    }

    const completed = items.filter((item) => {
      const latestReview = getLatestScreeningCaseReviewCompositeEntity(item.data.screening_case_review_composites);
      if (!latestReview) {
        return false;
      }
      return (
        latestReview.screening_case_review_status?.screening_case_review_status_key ===
        ScreeningCaseReviewStatusKey.complete
      );
    }).length;

    const percentage = Math.round((completed / total) * 100);

    return { completed, total, percentage };
  });
}
